module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-16.a5ae2abe.mp3";